<template>
  <section>
      <b-select
          size="sm"
          :options="getOptions"
          v-model="currentLanguage"
          v-on:change="langChange"
      ></b-select>
    <b-overlay :show="showOverlay > 0" class="overlay" rounded="sm"></b-overlay>
  </section>
</template>

<script>

    export default {
      name: "languagesSelect",
      props: {
        initLanguage: Array,
        change: Function,
      },
      components: {
      },
      data() {
        return {
          showOverlay: 0,
          languages: 0,
          currentLanguage: null,
        }
      },
      methods: {
        langChange() {
          this.change(this.currentLanguage)
        },
        sendRequest: function () {
          this.showOverlay ++
          this.$store.dispatch('SEND_GET', {
            url: '/languages',
            th: this,
            getSuccessResponse: (data) => {
              this.languages = data.data
            },
            getResponse: () => {
              this.showOverlay --;
            },
            showSuccessMessage: false
          })
        },
      },
      computed: {
        getOptions() {
          let buf = []
          for (let key in this.languages) {
            buf.push({
              text: this.languages[key].languages,
              value: this.languages[key].id,
            })
          }
          return buf
        }
      },
      mounted() {
      },
      created() {
        this.sendRequest()
        this.currentLanguage = this.initLanguage
      },
    }
</script>

<style scoped>
  .overlay {
    z-index: 51;
  }
</style>